import React from 'react';
import { LegalPage } from '../components/LegalPage';
import { termsAndConditions } from '../data/legal';
export function TermsPage() {
  return <LegalPage document={termsAndConditions} data-id="element-225" data-mp="25amjfsfwhyy9" />;
}